// https://www.geeksforgeeks.org/how-to-detect-touch-screen-device-using-javascript/
export function touchSupported(): boolean {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}
